import { VerifyURLResultKeys, URLStatus } from '@server/verify-url';
import { SfdcDisplayType } from '../../../../types/fields';

export const SfUrlVerificationFieldTypes = [
  SfdcDisplayType.DATETIME,
  SfdcDisplayType.URL,
  SfdcDisplayType.STRING,
  SfdcDisplayType.TEXTAREA,
  SfdcDisplayType.LONGTEXTAREA,
  SfdcDisplayType.EMAIL,
  SfdcDisplayType.URL,
  SfdcDisplayType.ENCRYPTEDSTRING,
  SfdcDisplayType.PHONE,
];

export const getVerifiedUrlOptionsByType = (
  sfDisplayType?: SfdcDisplayType,
  showVerifiedUrlOption?: string,
) => {
  const isOptionRedirect = showVerifiedUrlOption === URLStatus.REDIRECT;

  if (!sfDisplayType || !SfUrlVerificationFieldTypes.includes(sfDisplayType)) {
    //please add your type to UrlVerificationFieldTypes if you want it supported
    return [];
  }

  switch (sfDisplayType) {
    case SfdcDisplayType.DATETIME:
      return [VerifyURLResultKeys.verifyUrlTimestamp];

    case SfdcDisplayType.URL:
      if (isOptionRedirect) {
        return [
          VerifyURLResultKeys.finalRedirectUrl,
          VerifyURLResultKeys.originalUrl,
          VerifyURLResultKeys.finalRedirectDomain,
        ];
      } else if (showVerifiedUrlOption === URLStatus.VALID) {
        return [VerifyURLResultKeys.originalUrl];
      } else {
        return [VerifyURLResultKeys.originalUrl];
      }

    case SfdcDisplayType.STRING:
    case SfdcDisplayType.TEXTAREA:
    case SfdcDisplayType.EMAIL:
    case SfdcDisplayType.ENCRYPTEDSTRING:
    case SfdcDisplayType.PHONE:
    case SfdcDisplayType.LONGTEXTAREA:
      if (isOptionRedirect) {
        return [
          VerifyURLResultKeys.finalRedirectUrl,
          VerifyURLResultKeys.originalUrl,
          VerifyURLResultKeys.finalRedirectDomain,
        ];
      } else if (showVerifiedUrlOption === URLStatus.VALID) {
        return [VerifyURLResultKeys.originalUrl];
      } else {
        return [VerifyURLResultKeys.originalUrl, VerifyURLResultKeys.errorDetails];
      }
  }
};
